<template>
    <div>
        <div class="row" v-if="slides.length>0">
            <div class="col-md-12 col-sm-6 col-12 mt-4">
                <div id="sidebar-carousel">
                    <div class="car-header p-2" v-if="title" v-html="title">
                        <h5 class="m-0 p-2">{{ title }}</h5>
                    </div>
                    <div v-if="slides" class="bgColor pt-4">
                        <b-carousel 
                                    style="text-shadow: 1px 1px 2px #333;"
                                    controls
                                    :interval="4000"
                                    v-model="sliderIndex"
                        >

                            
                            <b-carousel-slide v-for="(slide, index) in slides" :key="index">
                                <img :src="slide.image.src" :alt="$options.filters.decoder(slide.image.alt)" :title="$options.filters.decoder(slide.image.title)" slot="img" class="w-60">
                            </b-carousel-slide>
                          

                        </b-carousel>
                        <div class="p-3 description">
                            <h1 v-if="slidecontent.title" v-html="$options.filters.decoder(slidecontent.title)"></h1>
                                
                            <p v-if="slidecontent.text" v-html="$options.filters.decoder(slidecontent.text)"></p>

                            <div class="text-center lees-meer">
                                <h5 class="m-0 p-0 pb-1">
                                    <a :href="slidecontent.link" v-if="slidecontent.link">
                                        Lees meer
                                    </a>
                                </h5>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'sidebar-carousel',
    props: {
        title : {
            type: String
        },
        slides : {
            type: Array
        },
    },
    data(){
      return {
        sliderIndex:0
      }  
    },
    computed : {
        slidecontent: function(){
            return this.slides[this.sliderIndex];
        }
    },
    filters:{
        decoder : function(value){
            if (!value) return ''
            return window.atob(value);
        }
    },
}
</script>


<style scoped>
    #sidebar-carousel .carousel-item{
        text-align: center;
    }
    #sidebar-carousel .carousel-item img{
        margin: 0 auto;
        width: 60%;
    }

    #sidebar-carousel .carousel-inner {
        height:auto;
    }
    #sidebar-carousel .carousel-inner > .item > img,
    #sidebar-carousel .carousel-inner > .item > a > img {
        margin: auto;
        min-height:initial;
    }
</style>





// WEBPACK FOOTER //
// src/components/overall_layouts/sidebar-carousel.vue